import { render, staticRenderFns } from "./onOkButtonClick-editor.vue?vue&type=template&id=59d7d474&scoped=true&"
import script from "./onOkButtonClick-editor.vue?vue&type=script&lang=js&"
export * from "./onOkButtonClick-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d7d474",
  null
  
)

export default component.exports